/* eslint-disable no-unused-vars */

import { REQUEST_STAFF_INFO } from "@/store/actions/staff";
import apiCall from "@/utils/api";

const state = {
  staffInfo: {},
};

const getters = {
  getStaffInfo: (state) => state.staffInfo,
};

const actions = {
  [REQUEST_STAFF_INFO]: async ({ commit, rootGetters }) => {
    const request = await apiCall({
      url: "staff-cards",
    });

    commit(REQUEST_STAFF_INFO, {
      response: request,
      lang: rootGetters.getLanguage,
    });

    return request;
  },
};

const mutations = {
  [REQUEST_STAFF_INFO]: (state, payload) => {
    const team = payload.response.data.filter(
      (item) => item.lang === payload.lang
    );

    state.staffInfo = {
      ...payload.response,
      data: {
        title: "about_us.our_team.title",
        description: "about_us.our_team.description",
        team,
      },
    };
  },
};

export default {
  state,
  getters,
  actions,
  mutations,
};
